module.exports = __webpack_public_path__ + "static/assets/7c5c45e6be4d8d6a7bdedaf5deea0aef.png";